import { setCookie, getCookie } from "./cookies";

export const cookieSessionName = window.ENV.AMPLITUDE_COOKIE_SESSION_NAME;
export const cookieDeviceName = window.ENV.AMPLITUDE_COOKIE_DEVICE_NAME;
export const amplitudeKey = window.ENV.AMPLITUDE_KEY;

export const setCookieSessionId = (sessionId) => {
  const sessionCookie = getCookie(cookieSessionName);

  if (!sessionCookie || sessionCookie !== sessionId) {
    setCookie(cookieSessionName, sessionId);
  }
};

export const setCookieDeviceId = (deviceId) => {
  const deviceCookie = getCookie(cookieDeviceName);

  if (!deviceCookie || deviceId !== deviceCookie) {
    setCookie(cookieDeviceName, deviceId);
  }
};

export const parseRequestAttributesFromLocation = (visitProperties) => {
  const props = { ...visitProperties };

  props.title = document.title;
  props.url = window.location.href;

  if (window.location.search !== "") {
    props.query = window.location.search;
    props.uri += window.location.search;
  } else {
    props.query = "none";
  }

  return props;
};
